module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_cycles-4011ac30dd673bdeecfabcec5862664c.png";